import React, { useState } from 'react';
import PropTypes from "prop-types";

import OutsideAlerter from 'components/outsideAlerter/outsideAlerter';
import ErrorMessage from 'components/errorMessage/errorMessage';
import Label from 'components/label/label';
import styles from './textArea.scss';

function TextArea(props) {

    const { name, label, placeholder, value, required, touched, onChange, onBlur, maxLength, textAreaClass, textAreaContainerClass, errors, showAllErrors, errorClass, invalidFieldClass, ...optionalProps } = props;
    const [ isActive, setIsActive] = useState(false);

    return (
        <div className={textAreaContainerClass}>
            <ErrorMessage
                {...{ errors, showAllErrors, errorClass, invalidFieldClass }}
                isErrorVisible={touched}
                renderChildren={invalidFieldClass => (
                    <React.Fragment>
                        <OutsideAlerter onOutsideClick={() => setIsActive(false)}>
                            <textarea
                                {...optionalProps}
                                id={name}
                                key={name}
                                value={value}
                                placeholder={placeholder}
                                maxLength={maxLength}
                                required={required}
                                onChange={(e) => onChange(e.target.value)}
                                onBlur={onBlur}
                                onClick={() => setIsActive(true)}
                                className={`${textAreaClass} ${invalidFieldClass} ${isActive ? styles.placeholdervisible: ""}`}
                            />
                            {label && <Label labelName={required ? label : `${label} (optional)`} labelClass={styles.label} />}
                        </ OutsideAlerter>
                        {
                            maxLength &&
                            <div className={styles.count}>
                                {value?.length}<span>/</span>{maxLength}
                            </div>
                        }
                    </React.Fragment>
                )}
            />
        </div>
    )
}

TextArea.defaultProps = {
    required: false,
    placeholder: " ",
    textAreaClass: styles.textarea,
    textAreaContainerClass: styles.textAreaContainer,
    invalidFieldClass: styles.error
}

TextArea.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    touched: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    errors: PropTypes.array,
    showAllErrors: PropTypes.bool,
}

export default TextArea
